module.exports = __webpack_public_path__ + "media/images/menu-e416519ccd7b59939134a4d8690922c6.png";